<h2>Reset Password</h2>
<form [formGroup]="frmSignup">
  <div class="form-group">
    <label for="password" [ngClass]="frmSignup.controls['password'].invalid ? 'tw:text-danger' : ''">Password:</label>
    <input id="password" formControlName="password" type="password" class="form-control" [ngClass]="f.password.invalid ? 'is-invalid' : ''">
    <div class="tw:w-full tw:px-[15px]">
      <label [ngClass]="f.password.hasError('required') || f.password.hasError('minlength')  ? 'tw:text-danger' : 'tw:text-success'">
        <i class="material-icons">
          {{ f.password.hasError('required') || f.password.hasError('minlength') ? 'cancel' :'check_circle' }}
        </i>
        Must be at least 8 characters!
      </label>
    </div>
    <div class="tw:w-full tw:px-[15px]">
      <label [ngClass]="f.password.hasError('required') || f.password.hasError('hasNumber')  ? 'tw:text-danger' : 'tw:text-success'">
        <i class="material-icons">
          {{ f.password.hasError('required') || f.password.hasError('hasNumber') ? 'cancel' : 'check_circle' }}
        </i>
        Must contain at least 1 number!
      </label>
    </div>
    <div class="tw:w-full tw:px-[15px]">
      <label [ngClass]="f.password.hasError('required') || f.password.hasError('hasCapitalCase')  ? 'tw:text-danger' : 'tw:text-success'">
        <i class="material-icons">
          {{ f.password.hasError('required') || f.password.hasError('hasCapitalCase') ? 'cancel' : 'check_circle' }}
        </i>
        Must contain at least 1 in Capital Case!
      </label>
    </div>
    <div class="tw:w-full tw:px-[15px]">
      <label [ngClass]="f.password.hasError('required') || f.password.hasError('hasSmallCase')  ? 'tw:text-danger' : 'tw:text-success'">
        <i class="material-icons">
          {{ f.password.hasError('required') || f.password.hasError('hasSmallCase') ? 'cancel' : 'check_circle' }}
        </i>
        Must contain at least 1 Letter in Small Case!
      </label>
    </div>
    <div class="tw:w-full tw:px-[15px]">
      <label [ngClass]="f.password.hasError('required') || f.password.hasError('hasSpecialCharacters') ? 'tw:text-danger' : 'tw:text-success'">
        <i class="material-icons">
          {{ f.password.hasError('required') || f.password.hasError('hasSpecialCharacters') ? 'cancel' : 'check_circle' }}
        </i>
        Must contain at least 1 Special Character!
      </label>
    </div>
    <div class="form-group">
      <label for="confirmPassword" [ngClass]="f.confirmPassword.invalid ? 'tw:text-danger' : ''">
        Confirm Password:
      </label>
      <input id="confirmPassword" formControlName="confirmPassword" type="password" class="form-control" [ngClass]="f.confirmPassword.invalid ? 'is-invalid' : ''">
      @if (f.confirmPassword.hasError('required')) {
        <label class="tw:text-danger"> Password is Required! </label>
      }
      @if (f.confirmPassword.hasError('NoPassswordMatch')) {
        <label class="tw:text-danger"> Password do not match </label>
      }
    </div>
    <div class="form-group">
      <button>Register</button>
    </div>
  </div>
</form>
